import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor($resource, $state, $timeout, Alert, UserPhoneNumber) {
        this.$resource = $resource;
        this.$timeout = $timeout;
        this.$state = $state;
        this.Alert = Alert;
        this.UserPhoneNumber = UserPhoneNumber;
    }

    $onInit() {
        this.phoneNumber = this.resolve.phoneNumber;
        this.verificationCode = '';
        const key = 'phone_numbers.sms_number.mobile_number_submitted';
        this.$timeout(() => this.spAlert = new SpAlert('info', key, {}, false));
    }

    resend() {
        this.$resource('app/rest/phonenumbers/:id/verificationresend')
            .save({id: this.phoneNumber.id}, null).$promise
            .then(() => {
                this.verificationCode = '';
                const key = 'phone_numbers.sms_number.verification_message';
                this.spAlert = new SpAlert('info', key);
            });
    }

    verify() {
        this.$resource('app/rest/phonenumbers/:id/verification')
            .save({id: this.phoneNumber.id}, {verificationCode: this.verificationCode})
            .$promise
            .then(() => {
                this.Alert('success', 'phone_numbers.sms_number.successful_verification');
                this.$state.go('user.mobile-numbers.list').then(()=>location.reload());
            })
            .catch((response) => {
                this.spAlert = new SpAlert('danger', response.data.message, {}, false);
            });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/verify/verify.controller.js